import(/* webpackMode: "eager" */ "/codebuild/output/src2986352793/src/src/app/global-error.tsx");
